import { Injectable } from '@angular/core';
import { ApplicationEventsEnum, LoginEvents } from '../models/events';
import { UserAuthData } from '../models/auth';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  constructor(private authService: AuthService) {
    window.addEventListener('message', this.eventListener.bind(this));
  }

  private eventListener(
    ev: MessageEvent<{ type: string; message: string }>,
  ): void {
    switch (ev.data.type) {
      case LoginEvents.Bootstrap: {
        const userData = JSON.parse(ev.data.message) as UserAuthData;
        this.authService.setUserAuthData(userData);
        return;
      }
    }
  }

  notifyParentOfTokenRefresh(userAuthData: UserAuthData): void {
    window.parent?.postMessage(
      {
        type: ApplicationEventsEnum.UserAuthDataRefreshed,
        message: userAuthData,
      },
      '*',
    );
  }

  notifyParent(event: ApplicationEventsEnum, message: string = ''): void {
    window.parent?.postMessage(
      {
        type: event,
        message,
      },
      '*',
    );
  }
}
